import styled from 'styled-components';

export const FlexContainer = styled.div`
    display: flex;
    align-items: center;
`;

export const Container = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const TemplateDetails = styled(Container)`
    margin-top: 16px;

    & > * {
        margin-bottom: 24px;
    }
`;
